import store from '@/store'
import { getMainMetadata, buildDescription } from '@/components/combined-predict/models/metadata'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'

const getToddsModelMetadata = () => {
  const keys = get(modelStateRegistry, 'groupedModel.keys')
  return store.getters[`toddsModels/${keys.getMetadata}`]
}

const getToddsModelIds = () => getToddsModelMetadata()?.endpoints?.map((endpoint) => Number(endpoint.modelId)) || []

const getToddsModelsMetadata = () => {
  const mainMetadata = getToddsModelMetadata()?.version
  const { name, compiled: compiledAt, description, build_id: buildId } = mainMetadata || {}

  return getMainMetadata({ name, compiledAt, description, buildId })
}

const getToddsModelsDescription = () => {
  const mainMetadata = getToddsModelsMetadata()
  return buildDescription(mainMetadata)
}

const getToddsModelsName = () => {
  const mainMetadata = getToddsModelsMetadata()
  return mainMetadata?.name ?? 'WebTEST v2'
}

const toddsModelsId = 'toddsModels'

const getToddsModelsCategory = () => ({
  id: toddsModelsId,
  name: getToddsModelsName(),
  description: getToddsModelsDescription(),
})

const getToddsModelEndpoint = (modelId) => {
  const metadata = getToddsModelMetadata()
  const modelMeta = metadata?.endpoints.find((endpoint) => String(endpoint.modelId) === String(modelId))
  if (!modelMeta) {
    console.warn(`No metadata found for ${modelId}, cannot build column groups.`)
    return null
  }
  return modelMeta
}

const getToddsModelName = (modelId) => {
  const modelMain = getToddsModelEndpoint(modelId)
  return modelMain?.propertyName ?? modelId
}

const getToddsModelDescription = (modelId) => {
  const modelMain = getToddsModelEndpoint(modelId)
  return modelMain?.propertyDescription ?? null
}

const getToddsModelUnit = (modelId) => {
  const modelMain = getToddsModelEndpoint(modelId)
  return modelMain?.unitsDisplay ?? null
}

export {
  toddsModelsId,
  getToddsModelIds,
  getToddsModelEndpoint,
  getToddsModelName,
  getToddsModelDescription,
  getToddsModelUnit,
  getToddsModelsDescription,
  getToddsModelsCategory,
}
